import { useEffect, useMemo, useState } from 'react'
import { isNativeApp, isOS } from '../../../client'
import { useOttOverlay } from '../../../contexts'
import { NavItem, ReshetNavItem } from './NavItem'
import {
  ArrowDownSymbol,
  ClosePopupButton,
  LeftMenuSeparator,
  NavigationListWrapper,
  NavigationLogo_13,
  NavigationLogo_13_desktop,
  NavigationLogo_13_mobile,
  NavigationWrapper,
  NavItemsLeft,
  NavItemsMain,
  NavItemsMainMedia,
  NavItemsMedia,
  PopupBackground,
  ReshetNavItemDivMedia,
} from './Navigation.style'
import { he } from '../../../locales/he'
import Link from 'next/link'
import { ottRoot } from '../../Api'

const MEDIA_REGEX = /(upload.*\/v)/

export const Navigation = () => {
  const { tree, searchPageID, logo } = useOttOverlay()
  const [isPopupOpen, setIsPopupOpen] = useState(false)
  const [state, setState] = useState({ isNative: false, isIos: false })

  const logoObj = useMemo(() => {
    return {
      d: logo?.replace(MEDIA_REGEX, 'upload/q_auto,f_auto,c_lpad,h_45,w_45/v'),
      m: logo?.replace(MEDIA_REGEX, 'upload/q_auto,f_auto,c_lpad,h_45,w_45/v'),
    }
  }, [logo])

  useEffect(() => {
    setState({ isNative: isNativeApp(), isIos: isOS() })
  }, [])

  const handlePopupOpen = () => {
    setIsPopupOpen(true)
  }

  const handlePopupClose = () => {
    setIsPopupOpen(false)
  }

  const [navItems, search] = useMemo(() => {
    const main: JSX.Element[] = [],
      left: JSX.Element[] = [
        <ReshetNavItem key={'reshet'} />,
        // <ProfileNavItem key={'profile'} />,
      ]
    if (tree) {
      tree.list.map((item, index) => {
        if (item.id === searchPageID) {
          left.push(<LeftMenuSeparator key={'Separator_' + index} />)
          left.push(<NavItem key={'search'} data={item} isIos={state.isIos} />)
        } else {
          main.push(<NavItem key={index} data={item} isIos={state.isIos} />)
        }
      })
      return [main, left]
    }
    return [[], false]
  }, [searchPageID, state.isIos, tree])

  if (isPopupOpen) {
    return (
      <PopupBackground>
        <NavItemsMainMedia onClick={() => handlePopupClose()}>
          {navItems}
        </NavItemsMainMedia>
        {!state.isNative && (
          <Link href={'/'}>
            <ReshetNavItemDivMedia
              isSearch={false}
              iosPaddingTop={state.isIos ? 3.6 : 13.6}
            >
              לאתר רשת 13
            </ReshetNavItemDivMedia>
          </Link>
        )}
        <ClosePopupButton onClick={() => handlePopupClose()}>
          <img
            src='https://media3.reshet.tv/image/upload/v1707140335/dev-uploads/2024/862014.webp'
            alt='profile'
          />
        </ClosePopupButton>
      </PopupBackground>
    )
  }

  return (
    <NavigationWrapper
      key={'NavigationWrapper'}
      isNative={state.isNative ? 'true' : 'false'}
    >
      {!state.isNative && (
        <NavigationListWrapper>
          <Link href={ottRoot}>
            <NavigationLogo_13>
              <NavigationLogo_13_desktop src={logoObj.d} alt={'רשת 13'} />
              <NavigationLogo_13_mobile src={logoObj.m} alt={'רשת 13'} />
            </NavigationLogo_13>
          </Link>
          <NavItemsMain>{navItems}</NavItemsMain>
        </NavigationListWrapper>
      )}
      <NavItemsMedia
        onClick={() => handlePopupOpen()}
        isNative={state.isNative ? 'true' : 'false'}
      >
        {he.categories}
        <ArrowDownSymbol />
      </NavItemsMedia>
      <NavItemsLeft>{search}</NavItemsLeft>
    </NavigationWrapper>
  )
}
